const archive = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const form = document.getElementById("archiveFilterForm");
    const container = document.getElementById("archiveResults");
    const paginationWrap = document.getElementById("archivePagination");
    const spinner = document.getElementById("archiveSpinner");
    if (!form || !container || !paginationWrap) return;

    const toggleSpinner = (show) => {
      if (!spinner) return;
      spinner.classList.toggle("d-none", !show);
      spinner.setAttribute("aria-hidden", show ? "false" : "true");
    };

    // Dropdown
    const filterBoxes = form.querySelectorAll(".archive__filter__box");
    filterBoxes.forEach((filterBox) => {
      const btn = filterBox.querySelector(".archive__filter__btn");
      const list = filterBox.querySelector(".archive__filter__list");
      if (!btn || !list) return;

      btn.addEventListener("click", () => {
        filterBoxes.forEach((other) => (other === filterBox ? null : other.classList.remove("active")));
        filterBox.classList.toggle("active");
      });

      window.addEventListener("click", (e) => {
        if (!filterBox.classList.contains("active")) return;
        const inside = list.contains(e.target) || btn.contains(e.target);
        if (!inside) filterBoxes.forEach((b) => b.classList.remove("active"));
      });
    });

    // "Seleziona tutti" (reset box)
    const handleSelectAllLogic = (scope) => {
      const box = form.querySelector(`.archive__filter__box[data-filter="${scope}"]`);
      if (!box) return;

      const checks = box.querySelectorAll(`input[name="${scope}[]"].archive__filter__checkbox`);
      const selectAll = box.querySelector(`input[name="${scope}[]"][value="any"]`);

      checks.forEach((chk) => {
        chk.addEventListener("change", () => {
          if (chk === selectAll && selectAll.checked) {
            checks.forEach((c) => (c.checked = false));
            selectAll.checked = true; // unico selezionato
          } else {
            if (selectAll.checked) selectAll.checked = false;
            const anyOther = Array.from(checks).some((c) => c !== selectAll && c.checked);
            if (!anyOther) selectAll.checked = true;
          }
          fetchResults({ paged: 1 });
        });
      });
    };

    handleSelectAllLogic("category");
    handleSelectAllLogic("tag");

    // Submit (sicurezza)
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      fetchResults({ paged: 1 });
    });

    // Delegation per la paginazione (prev/next + numeri)
    document.addEventListener("click", (e) => {
      const a = e.target.closest("#archivePagination a.page-numbers");
      if (!a) return;
      e.preventDefault();

      // pagina corrente visualizzata (span non link)
      const currentEl = document.querySelector("#archivePagination .archive__pagination__item.current .archive__pagination__label");
      const currentNum = currentEl ? parseInt(currentEl.textContent.trim(), 10) : 1;

      let paged = NaN;

      // 1) data-page
      if (a.dataset.page && /^\d+$/.test(a.dataset.page)) {
        paged = parseInt(a.dataset.page, 10);
      }

      // 2) testo del link
      if (Number.isNaN(paged) && /^\d+$/.test(a.textContent.trim())) {
        paged = parseInt(a.textContent.trim(), 10);
      }

      // 3) parse da href .../page/2/...
      if (Number.isNaN(paged) && a.href) {
        const match = a.href.match(/\/page\/(\d+)(?:[\/\?]|$)/i);
        if (match) paged = parseInt(match[1], 10);
      }

      // 4) prev/next
      if (Number.isNaN(paged)) {
        if (a.classList.contains("prev")) paged = Math.max(1, currentNum - 1);
        else if (a.classList.contains("next")) paged = currentNum + 1;
      }

      if (Number.isNaN(paged) || paged === currentNum) return;
      fetchResults({ paged });
    });

    const serializeFilters = () => {
      const fd = new FormData(form);
      return {
        s: fd.get("s") || "",
        category: fd.getAll("category[]") || [],
        tag: fd.getAll("tag[]") || [],
        base_taxonomy: fd.get("base_taxonomy") || "category",
        base_term: parseInt(fd.get("base_term") || "0", 10),
      };
    };

    const fetchResults = ({ paged = 1 } = {}) => {
      const data = serializeFilters();
      toggleSpinner(true);

      $.ajax({
        url: ajax_auth_object.ajaxurl,
        method: "POST",
        data: {
          action: "filter_post",
          apply_coupon_nonce: ajax_auth_object.apply_coupon_nonce,
          s: data.s,
          category: data.category,
          tag: data.tag,
          paged: paged,
          base_taxonomy: data.base_taxonomy,
          base_term: isNaN(data.base_term) ? 0 : data.base_term,
        },
        success: (resp) => {
          if (!resp?.success || !resp.data) return;
          const payload = resp.data;

          if (typeof payload.items_html === "string") {
            container.innerHTML = payload.items_html;
          }
          if (typeof payload.pagination_html === "string") {
            paginationWrap.innerHTML = payload.pagination_html;
          }
        },
        error: (err) => console.error("Errore AJAX:", err),
        complete: () => toggleSpinner(false),
      });
    };
  });
};

export default archive;
